import TitleBar from "../components/TitleBar";

const board = [
  {
    office: "President",
    officers: ["Kevin Roberts"],
  },
  {
    office: "Secretary/Treasurer",
    officers: ["Chris Koop"],
  },
  {
    office: "Assistant Secretary",
    officers: ["Marge Washburn"],
  },
  {
    office: "Directors",
    officers: [
      "Mike Brown",
      "Alan Conkle",
      "Terry Eckert",
      "Walt Hazelton",
      "Charlie Miller",
      "Stephen Wilde",
    ],
  },
  {
    office: "Office Staff",
    officers: ["Sherry Wilde, Manager", "Shannon LaForce, Assistant Manager", "Jessica Baez, Administrative Assistant"],
  },
];

export default function About() {
  return (
    <>
      <TitleBar />
      <main className="w-full">
        <div className="mx-auto max-w-[85rem] px-8">
          <section className="mt-4">
            <h1 className="my-2 font-serif text-3xl font-bold italic text-(--darkred)">
              About EVTCC
            </h1>
            <p className="my-2">
              The EVT Certification Commission, Inc. is a nonprofit corporation
              dedicated to improving the quality of emergency vehicle service
              and repair throughout the United States and Canada by means of a
              certification program that will provide technicians recognition
              for the education, training, and experience they have in the
              service and repair of emergency vehicles.{" "}
            </p>
          </section>
          <section>
            <h2 className="my-2 font-serif text-2xl font-bold italic text-(--darkred)">
              Board of Directors
            </h2>
            {board.map((position) => (
              <div className="my-2 mb-4" key={position.office}>
                <h3 className="ml-2 font-serif text-xl font-bold italic">
                  {position.office}
                </h3>
                <div className="ml-4">
                  {position.officers.map((of) => (
                    <div key={of}>
                      {of}
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </section>
        </div>
      </main>
    </>
  );
}
